import { createRequestData, getRequestData, searchRequestData, updateRequestData } from "../../Utility/apiHelper";
import { requestHideLoader, requestShowLoader } from "../Global/action";
import * as actionType from './type';

export const requestgetAllTasks = (queryparams) => async (dispatch) => {
    dispatch(requestShowLoader())
    try {
        const taskSearchUrl = `${process.env.REACT_APP_BASE_URL}tasks`;
        const responsedata = await searchRequestData(queryparams, taskSearchUrl, false)
        dispatch({
            type: actionType.RECEIVED_ALL_TASKS,
            payload: responsedata?.data
        })

    } catch (error) {
    }
    dispatch(requestHideLoader())
}

export const requestGetTasksPaged = (queryparams) => async (dispatch) => {
    dispatch({ type: actionType.REQUEST_GET_PAGED_TASKS })
    dispatch(requestShowLoader())
    try {
        const taskPagedUrl = `${process.env.REACT_APP_BASE_URL}tasks/paged`;
        const responsedata = await searchRequestData(queryparams, taskPagedUrl, false)
        dispatch({
            type: actionType.RECEIVED_PAGED_TASKS,
            payload: responsedata?.data
        })
    } catch (error) {
    }
    dispatch(requestHideLoader())
}


export const requestGetTaskStatusBased = (queryparams) => async (dispatch) => {
    try {
        const url = `${process.env.REACT_APP_BASE_URL}tasks/statusbased`;
        const responsedata = await searchRequestData(queryparams, url, false);
        dispatch({
            type: actionType.RECEIVED_TASK_STATUSBASED,
            payload: responsedata?.data
        });
    } catch (error) {
    }
};

export const requestGetSubtasks = (parentTaskId) => async (dispatch) => {
    dispatch(requestShowLoader());
    try {
        const url = `${process.env.REACT_APP_BASE_URL}tasks/${parentTaskId}/subtasks`;
        const responsedata = await getRequestData(url);
        dispatch({
            type: actionType.RECEIVED_SUBTASKS,
            payload: responsedata?.data
        });
    } catch (error) {
    }
    dispatch(requestHideLoader());
};

export const requestUpdateTaskStatus = (tasks, onSuccess, onError) => async (dispatch) => {
    dispatch(requestShowLoader());
    dispatch({ type: actionType.UPDATE_TASK_STATUS_LOADING });

    try {
        const url = `${process.env.REACT_APP_BASE_URL}tasks/status`;
        const response = await updateRequestData(tasks, url);

        if (response?.status === 200) {
            dispatch({
                type: actionType.UPDATE_TASK_STATUS_SUCCESS,
                payload: tasks
            });
            dispatch(requestHideLoader());
            if (onSuccess) onSuccess(response);
        } else if (response?.propererror?.status === 409 || response?.status === 409) {
            const conflictData = response?.propererror?.data || response?.data;
            dispatch({
                type: actionType.UPDATE_TASK_STATUS_CONFLICT,
                payload: conflictData
            });
            dispatch(requestHideLoader());
            if (onError) onError(response?.propererror || response);
        } else {
            throw new Error(response?.propererror?.data?.message || 'Failed to update task status');
        }
    } catch (error) {
        dispatch({
            type: actionType.UPDATE_TASK_STATUS_ERROR,
            payload: error?.response?.data?.message || error?.message || 'Failed to update task status'
        });
        dispatch(requestHideLoader());

        if (onError && error?.response?.status !== 401) {
            onError(error);
        }
    }
};

export const requestGetTask = (taskId, onSuccess, onError) => async (dispatch) => {
    dispatch(requestShowLoader());
    const url = `${process.env.REACT_APP_BASE_URL}tasks/${taskId}`;
    const response = await getRequestData(url);
    dispatch(requestHideLoader());
    if (response?.data) {
        if (onSuccess) onSuccess(response.data);
    } else {
        const status = response?.response?.status || response?.status;
        if (onError && status !== 401) {
            onError(response);
        }
    }
};

export const requestCreateCustomerForTask = (taskId, customerDto, onSuccess, onError) => async (dispatch) => {
    dispatch(requestShowLoader());
    const url = `${process.env.REACT_APP_BASE_URL}tasks/${taskId}/customer`;
    const response = await createRequestData(customerDto, url);
    dispatch(requestHideLoader());
    if (response?.status === 200 || response?.status === 201) {
        if (onSuccess) onSuccess(response.data);
    } else {
        if (onError && response?.propererror?.status !== 401) {
            onError(response?.propererror);
        }
    }
};
